module.exports = __webpack_public_path__ + "images/swedish-white.png";


//////////////////
// WEBPACK FOOTER
// ./assets/swedish-white.png
// module id = 7
// module chunks = 0